export const expressServiceDetail = {
  "standard-express": {
    title: "标快",
    introduction:
      '在指定服务范国和寄递时间内收寄，实行标准定价，提供时效承诺，加以“时效保障”、“标准服务”、“快速理赔”"为支撑为客户提供“稳定、安全、可靠”的高品质、门到门快递服务',
    advantages: [
      "1、时效保障",
      "2、标准服务",
      "3、快速理赔",
      "4、派前电联",
      "5、送货上门",
    ],
    opened: [
      {
        title: ['1、普通电子面单、抖音电子面单账户：', '客户申请一网点审核→总部审核'],
        detail: [
          "① 客户申请：在快递管家→基础设置→基础信息→増值服务申请，找到相应増值服务，点击开通按钮，提交内外物包装图片、及相关信息，申请开通标快权限",
          "② 网点审核",
        ]
      },
      {
        title: ['2、菜鸟、拼多多电子面单账户：', '客户平台申请→网点审核'],
        detail: [
          "淘宝商家：千牛卖家中心-物流管理一电子面单平台一我的服务商，找到之前申请的电子面单账号，服务开通选择标快，提交申请",
          { type: 'img', src: require("@/assets/express-service/detail/standard-express/pic1.png")},
          { type: 'img', src: require("@/assets/express-service/detail/parcel-insurance/pic2.png")},
          "拼多多商家：拼多多商家服务后台->发货管理->电子面单->开通电子面单服务->（已开通的服务商）展开->管理->开通服务",
          { type: 'img', src: require("@/assets/express-service/detail/parcel-insurance/pic3.png")},
          { type: 'img', src: require("@/assets/express-service/detail/parcel-insurance/pic4.png")},
          { type: 'img', src: require("@/assets/express-service/detail/parcel-insurance/pic5.png")},
        ]
      },
      {
        title: ['3、协议快递员：', '客户申请 →业务员审核 '],
        detail: [
          "① 客户申请：在快递管家→基础设置→基础信息→增值服务申请，找到相应增值服务，点击开通按钮，申请开通标快权限；",
          "② 业务员审核"
        ]
      },
    ],
    openedInfo: {
      title: ['开通信息：寄递物内外包装图片']
    },
    process: [
      '生鲜、易腐、易损快件需网点申请经总部包装备案审核后方可发货'
    ],
    charge: [
      "与发件网点协商"
    ],
    hotline: "联系当地网点"
  },

  "normal-express": {
    title: "普快",
    introduction:
      "实现全渠道可下单，提供中国境内全境可送达，高性价比的快递服务产品。",
    advantages: ["全渠道下单", "境内网点全覆盖", "性价比高"],
  },

  "parcel-insurance": {
    title: "保价",
    introduction:
      "确保高客单价物品快件安全转运，保障客户利益推出的保价业务。",
    advantages: [
      "1、电子面单，操作简单",
      "2、保险公司兜底，价低有保障",
      "3、专属客服，保丢保损",
      "4、独立交接，绿色通道（标快通道）",
      "5、优先派送、派前电联、先验货后签收",
    ],
    opened: [
      {
        title: ['1、普通电子面单、抖音电子面单账户： ', '客户申请→网点审核→总部审核'],
        detail: [
          "① 客户申请：在快递管家→基础设置→基础信息→増值服务申请，找到相应增值服务，点击开通按钮，提交内外物包装图片、物品名称，申请开通保价权限；",
          "② 网点审核：网点提交《保价备案表》",
          "③ 总部审核"
        ]
      },
      {
        title: ['2、菜鸟、拼多多电子面单账户：', '客户申请→网点审核（合同签署）→总部审核'],
        detail: [
          "① 客户申请：",
          "淘宝商家：淘宝商家服务后台-物流管理-物流服务-电子面单平台-我的服务商-服务开通，找到之前申请的电子面单账号，服务开通选择保价，提交申请",
          { type: 'img', src: require("@/assets/express-service/detail/parcel-insurance/pic1.png")},
          { type: 'img', src: require("@/assets/express-service/detail/parcel-insurance/pic2.png")},
          "拼多多商家：拼多多商家后台-发货管理-电子面单-开通电子面单服务-（已申请的服务商）展开-管理-点击开通，选择保价，提交申请",
          { type: 'img', src: require("@/assets/express-service/detail/parcel-insurance/pic3.png")},
          { type: 'img', src: require("@/assets/express-service/detail/parcel-insurance/pic4.png")},
          { type: 'img', src: require("@/assets/express-service/detail/parcel-insurance/pic5.png")},
          "② 网点审核：发货前需联系保价项目组线下备案",
        ]
      },
      {
        title: ['3、协议快递员：', '客户申请 →业务员审核 '],
        detail: [
          "① 客户申请：在快递管家→基础设置→基础信息→增值服务申请，找到相应增值服务，点击开通按钮，申请开通保价权限；",
          "② 业务员审核"
        ]
      },
    ],
    process: [
      { type: 'img', src: require("@/assets/express-service/detail/parcel-insurance/pic_liucheng.png") }
    ],
    charge: [
      { type: 'img', src:  require("@/assets/express-service/detail/parcel-insurance/biaoge.png") },
      "赔偿标准：保价快件，按照实际价值损失赔偿，但最高不超过申报价值；如快件未足额保价的，则赔偿金额按保价率折扣，即赔偿金额=实际价值损失*申报价值/实际价值；"
    ],
    hotline: "咨询热线：021-31080215或联系当地网点"
  },

  "signing-retrun": {
    title: "签单返还",
    introduction:
      "应寄件方要求，将收件方签收确认后的签收单、出库单、收货清单、发票等各种单据在规定的服务时间内返还给寄件方的一种增值服务。",
    advantages: ["1、保障交易安全", "2、方便客户对账结算", "3、送货上门，一对一核对"],
    opened: [
      {
        title: ['1、普通电子面单：', '客户申请→网点审核'],
        detail: [
          "① 客户申请：在快递管家→基础设置→基础信息→増值服务申请，找到相应增值服务，点击开通按钮，申请开通签单返还权限；",
          "② 网点审核",
        ]
      },
      {
        title: ['2、协议快递员：', '客户申请→业务员审核'],
        detail: [
          "① 客户申请：在快递管家→基础设置→基础信息→増值服务申请，找到相应増值服务，点击开通按钮，申请开通签单返还权限;",
          "② 业务员审核",
        ]
      },
    ],
    openedInfo: { 
      title: [
        '开通信息：无，需与网点达成一致',
      ],
    },
    process: [
      { type: 'img', src:  require("@/assets/express-service/detail/signing-retrun/yelc.png") }
    ],
    charge: [
      '与发件网点协商'
    ],
    hotline: "咨询电话：021-31185787或联系当地网点"
  },

  "payment-collect": {
    title: "代收货款",
    introduction:
      "按照寄件方（卖家）与收件方（买家）达成交易协议的要求，为寄件方提供承运、寄递物品的同时，并代寄件方向收件方收取货款，同时按照约定时间将货款返还给寄件方的服务，简称为COD。",
    introductions: [
      "根据返款方式、返款周期、返款费率的不同，分为以下3种",
      "1、普通COD：中通网点线下返款，返款周期与费率与网点协商",
      "2、T1COD：中通总部线上返款，签收日T+1返款，费率为代收金额的1%",
      "3、T3COD：又叫快递管家COD，中通总部线上返款，签收日T+3返款，费率：300元以下2元，300元以上为代收金额的1%",
    ],
    advantages: [
      "1、快速返款、周期灵活、轻松对账",
      "2、支持现金、微信、支付宝等多种付款方式",
      "3、产品多样性选择（网点返款，总部返款，不同返款周期）",
    ],
    opened: [
      {
        title: ['1、普通COD：', '客户申请 →网点审核'],
        detail: [
          "① 网点开通：网点在客户管理系统，找到相应増值服务，点击开通按钮，申请开通普通COD权限；",
          "② 网点审核"
        ]
      },
      {
        title: ['2、T1COD/T3COD：', '客户申请→网点审核（合同签署）→总部审核'],
        detail: [
          "① 客户申请：在快递管家→基础设置→基础信息→增值服务申请，找到相应增值服务，点击开通按钮，提交客户营业执照、身份证正反面、银行卡信息（账号/开户行信息/银行卡正面照片），申请开通T1COD/T3COD权限；",
          "② 网点审核：网点与客户签署《服务合同》、《平台使用协议》",
          "③ 总部审核"
        ]
      },
      {
        title: ['3、协议快递员：', '客户申请 →业务员审核 '],
        detail: [
          "① 客户申请：在快递管家→基础设置→基础信息→増值服务申请，找到相应增值服务，点击开通按钮，申请开通普通COD权限；",
          "② 业务员审核"
        ]
      },
    ],
    openedInfo: { 
      title: [
        '开通信息：',
        '①普通COD：无',
        '②T1COD/T3COD：客户营业执照、身份证正反面、银行卡信息(账号、开户行信息、银行卡正面照片)、快递服务合同、服务协议',
      ],
      detail: [
        '注意事项：',
        '1.  发件人号码必须填写面单上的发件人号码，否则将会导致审核不通过；',
        '2. “服务合同”及“服务协议”必须签字盖公司公章。由网点进行上传；',
        '3.  客户如果要更换打单手机号或者终止合作，需提前在申请界面修改和关闭；',
        '4.  只支持快递管家网页版打单的代收；',
        '5.  快递管家提供代收账单功能，客户请按时核实，有问题超过三个月不予处理；',
        '6.  退件单号联系网点，网点必须到费用申诉系统里面申请取消代收，再签收。',
      ] 
    },
    process: [
      { type: 'img', src:  require("@/assets/express-service/detail/payment-collect/pic_liucheng.png") }
    ],
    charge: [
      { type: 'img', src: require("@/assets/express-service/detail/payment-collect/sfbg.png") }
    ],
    hotline: "咨询电话：021-31080223/021-31080221或联系当地网点"
  },

  "bill-privacy": {
    title: "隐私面单",
    introduction:
      "在面单上，通过虚拟号码替换了客户的真实手机号码或将客户真实号码中间4位隐藏，保护客户信息不被泄露。",
  },

  "freight-collect": {
    title: "到付",
    introduction:
      "在收件人和寄件人达成一致的情况下，物流运输的费用由收件人承担，在货物到达后支付费用给物流公司的一项增值服务。",
    advantages: [
      "为您提供快递活动中更灵活、更全面的服务。该业务适用于所有有到付需求的客户",
    ],
    opened: [
      {
        title: ['1、普通COD：', '客户申请→网点审核（合同签署）→总部审核'],
        detail: [
          "① 客户申请：在快递管家→基础设置→基础信息→增值服务申请，找到相应增值服务，点击开通按钮，提交客户营业执照（或身份证正反面），申请开通到付权限；",
          "② 网点审核：网点与客户签署《服务合同》、网点提交《网点保证书》",
          "③ 总部审核"
        ]
      },
      {
        title: ['2、协议快递员：', '客户申请 →业务员审核 '],
        detail: [
          "① 客户申请：在快递管家→基础设置→基础信息→増值服务申请，找到相应增值服务，点击开通按钮，申请开通到付权限",
          "② 业务员审核"
        ]
      },
    ],
    openedInfo: { 
      title: [
        '开通信息：客户提交客户营业执照（或身份证正反面）、并与网点签署《快递服务合同》；网点上传《服务合同》《网点保证书》进行审核。',
      ],
      detail: [
        '注意事项：',
        '1. ①务必确认为客户的营业执照，且全图上传。②如客户无营业执照，请提供客户身份证正反面照片。',
        '2. “服务合同”及“服务协议”必须签字盖公司公章。由网点进行上传。',
      ] 
    },
    process: [
      { type: 'img', src:  require("@/assets/express-service/detail/freight-collect/yelc.png") }
    ],
    charge: [
      "与发件网点协商"
    ],
    hotline: "咨询电话：021-31080223或联系当地网点"
  },
  "respect-enjoy": {
    title: "尊享",
    introduction:
      "针对中高端客户提供的派前电联、主动售后等多项高质量服务的增值服务产品。",
    advantages: [
      "绿色中转",
      "派前电联",
      "全程售后服务跟踪，让您尊享贵宾般售后体验",
    ],
    opened: [
      {
        title: ['1、普通电子面单、抖音电子面单账户：', '客户申请  →网点审核'],
        detail: [
          "① 客户申请：在快递管家→基础设置→基础信息→增值服务申请，找到相应增值服务，点击开通按钮，申请开通尊享权限；",
          "② 网点审核"
        ]
      },
      {
        title: ['2、菜鸟、拼多多电子面单账户：', '客户平台申请  →网点审核 '],
        detail: [
          "①客户申请：",
          "淘宝商家：干牛卖家中心一物流管理一物流服务-电子面单平台一我的服务商，找到之前申请的电子面单账号，服务开通选择VIP尊享，提交申请，联系网点/总部审核",
          { type: 'img', src: require("@/assets/express-service/detail/respect-enjoy/pic1.png")},
          { type: 'img', src: require("@/assets/express-service/detail/respect-enjoy/pic2.png")},
          "拼多多商家：拼多多商家服务后台->发货管理->电子面单->开通电子面单服务->(已开通的服务商) 展开->管理->开通服务",
          { type: 'img', src: require("@/assets/express-service/detail/respect-enjoy/pic3.png")},
          { type: 'img', src: require("@/assets/express-service/detail/respect-enjoy/pic4.png")},
          { type: 'img', src: require("@/assets/express-service/detail/respect-enjoy/pic5.png")},
        ]
      },
      {
        title: ['3、协议快递员 ：', '客户申请 →业务员审核'],
        detail: [
          "① 客户申请：在快递管家→ 基础设置→ 基础信息 → 增值服务申请，找到相应增值服务，点击开通按钮，申请开通尊享权限；",
          "② 业务员审核"
        ]
      },
    ],
    openedInfo: { 
      title: [
        '开通信息：无，需与网点达成一致',
      ]
    },
    process: [
      '无特殊业务流程，保障使用面单有尊享标识，同时中通快件跟踪系统查询有增值服务-尊享信息即可'
    ],
    charge: [
      "服务收费与发件网点协商"
    ],
    hotline: "咨询热线：021-31185787或联系当地网点"
  },
};
